import { closeModal } from "../../../ui/containers/Modal";
import { floodFill } from "../../../ui/helpers";
import { ComponentF } from "../../../ui/ui";
import Colors from "../../Colors";
import { gameData } from "../../GameManager";
import { isDownKey, isUpKey } from "../keyHelper";

const levelOptions = [
  {
    title: "Health (+20)",
    description: "How much punishment you can take",
    apply: () => {
      gameData.player.level = gameData.player.level + 1;
      gameData.player.health.adjustMax(20, false);
    },
  },
  {
    title: "Stamina (+20)",
    description: "How much you can do before tiring",
    apply: () => {
      gameData.player.level = gameData.player.level + 1;
      gameData.player.stamina.adjustMax(20);
    },
  },
  {
    title: "Max Weight (+5)",
    description: "How much equipment load you can wear",
    apply: () => {
      gameData.player.level = gameData.player.level + 1;
      gameData.player.attributes.weight = gameData.player.attributes.weight + 5;
    },
  },
  {
    title: "Force (+1)",
    description: "How impactful your blows are",
    apply: () => {
      gameData.player.level = gameData.player.level + 1;
      gameData.player.attributes.force = gameData.player.attributes.force + 1;
    },
  },

  {
    title: "Strength (+1)",
    description: "How big a weapon you can wield",
    apply: () => {
      gameData.player.level = gameData.player.level + 1;
      gameData.player.attributes.strength =
        gameData.player.attributes.strength + 1;
    },
  },
];
export const LevelModal: ComponentF<{
  title: string;
}> = (C, props) => {
  const [state, setState] = C.useState({
    selected: 0,
  });

  floodFill(C.display, C.bounds, Colors.BLACK);
  let y = C.bounds.y;
  C.display.drawText(C.bounds.x, y, "Level Up");
  y += 1;
  C.display.drawText(C.bounds.x, y, "Select a stat to improve");
  y += 2;

  levelOptions.forEach((opt, index) => {
    let color = Colors.B_GREY_3;
    let subColor = Colors.B_GREY_2;
    if (state.selected === index) {
      color = Colors.B_GREY_5;
      subColor = Colors.B_GREY_4;
      C.display.drawText(C.bounds.x, y, ">");
    }
    C.display.drawText(C.bounds.x + 1, y, `%c{${color}}${opt.title}`);
    y += 1;
    C.display.drawText(C.bounds.x + 2, y, `%c{${subColor}}${opt.description}`);
    y += 2;
  });

  C.display.drawText(
    C.bounds.x,
    C.bounds.y + C.bounds.h - 1,
    `%c{${Colors.RED_4}} Enter %c{}Confirm %c{${Colors.RED_4}}Esc%c{} Cancel`
  );

  C.handlers.keypress = (key: string) => {
    if (isUpKey(key) && 0 < state.selected) {
      setState({ selected: state.selected - 1 });
    } else if (isDownKey(key) && state.selected < levelOptions.length - 1) {
      setState({ selected: state.selected + 1 });
    } else if (key === "Enter") {
      levelOptions[state.selected].apply();
      closeModal();
      return true;
    } else if (key === "Escape") {
      closeModal();
      return true;
    }
    return true;
  };
};
